import { BASE_ENDPOINT } from "../../endpoint";

export const retrieveDashboardOverviewService = async (token: string) => {
    try {
        const response = await fetch(`${BASE_ENDPOINT}/user/dashboard/retrieve/batch`, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch dashboard data`);
        }
        return await response.json(); 
    } catch (error) {
        console.error("Error retrieving dashboard data:", error);
        throw error;
    }
};
